/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COLORS, RETAILER_COLORS } from '@components/web/src/styles';

export const createLinearGradient = (from: string, to: string) => `linear-gradient(180deg, ${from} 0%, ${to} 100%)`;

export const GRADIENTS = {
  warmGradient() {
    return createLinearGradient(COLORS.warmGray[100], COLORS.base.white);
  },
  warmGradientReversed() {
    return createLinearGradient(COLORS.base.white, COLORS.warmGray[100]);
  },
  retailerSecondaryColorGradient() {
    return createLinearGradient(RETAILER_COLORS.secondary['100'], COLORS.base.white);
  },
  retailerSecondaryColorGradientReversed() {
    return createLinearGradient(COLORS.base.white, RETAILER_COLORS.secondary['100']);
  },
  primaryGradient: 'linear-gradient(45deg, #3d80c1 0%, #24a360 100%)',
  secondaryGradient: 'linear-gradient(to right, #3d80c1 0%, #24a360 100%)',
  warmGradientForSkeleton: 'linear-gradient(90deg, #c8c6bb 0.69%, rgb(225 224 217 / 0%) 100.69%)',
  characterGradient: `linear-gradient(180deg, #fbf5f9 0%, ${RETAILER_COLORS.product['50']} 100%)`,
  productGradient: `radial-gradient(98% 98% at 51.6% 100%, ${RETAILER_COLORS.product['200']} 0%, ${RETAILER_COLORS.product['500']} 99.58%)`,
} as const;
